import { render, staticRenderFns } from "./AddSundryItemInvoiceFilePopUp.vue?vue&type=template&id=fad25806&scoped=true&"
import script from "./AddSundryItemInvoiceFilePopUp.vue?vue&type=script&lang=js&"
export * from "./AddSundryItemInvoiceFilePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad25806",
  null
  
)

export default component.exports